var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg7595 = function Svg7595(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M1 6a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V6Z",
    stroke: "#9AA0AB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6Z",
    fill: "#9AA0AB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7v2",
    stroke: "#9AA0AB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { Svg7595 as ReactComponent };
export default "data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M1 6C1 4.89543 1.89543 4 3 4L11.0003 4C12.1049 4 13.0003 4.89543 13.0003 6V10C13.0003 11.1046 12.1049 12 11.0003 12H3C1.89543 12 1 11.1046 1 10V6Z' stroke='%239AA0AB' stroke-linecap='round' stroke-linejoin='round'/%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M2 6C2 5.44772 2.44772 5 3 5L9 5C9.55228 5 10 5.44772 10 6V10C10 10.5523 9.55228 11 9 11H3C2.44772 11 2 10.5523 2 10V6Z' fill='%239AA0AB'/%3E %3Cpath d='M15 7V9' stroke='%239AA0AB' stroke-linecap='round' stroke-linejoin='round'/%3E %3C/svg%3E";